export default [
  { name: 'Aceh', code: 'AC' },
  { name: 'Bali', code: 'BA' },
  { name: 'Bangka Belitung', code: 'BB' },
  { name: 'Banten', code: 'BT' },
  { name: 'Bengkulu', code: 'BE' },
  { name: 'Gorontalo', code: 'GO' },
  { name: 'Jakarta', code: 'JK' },
  { name: 'Jambi', code: 'JA' },
  { name: 'Jawa Barat', code: 'JB' },
  { name: 'Jawa Tengah', code: 'JT' },
  { name: 'Jawa Timur', code: 'JI' },
  { name: 'Kalimantan Barat', code: 'KB' },
  { name: 'Kalimantan Selatan', code: 'KS' },
  { name: 'Kalimantan Tengah', code: 'KT' },
  { name: 'Kalimantan Timur', code: 'KI' },
  { name: 'Kalimantan Utara', code: 'KU' },
  { name: 'Kepulauan Riau', code: 'KR' },
  { name: 'Lampung', code: 'LA' },
  { name: 'Maluku', code: 'MA' },
  { name: 'Maluku Utara', code: 'MU' },
  { name: 'North Sumatra', code: 'SU' },
  { name: 'Nusa Tenggara Barat', code: 'NB' },
  { name: 'Nusa Tenggara Timur', code: 'NT' },
  { name: 'Papua', code: 'PA' },
  { name: 'Papua Barat', code: 'PB' },
  { name: 'Riau', code: 'RI' },
  { name: 'South Sumatra', code: 'SS' },
  { name: 'Sulawesi Barat', code: 'SR' },
  { name: 'Sulawesi Selatan', code: 'SN' },
  { name: 'Sulawesi Tengah', code: 'ST' },
  { name: 'Sulawesi Tenggara', code: 'SG' },
  { name: 'Sulawesi Utara', code: 'SA' },
  { name: 'West Sumatra', code: 'SB' },
  { name: 'Yogyakarta', code: 'YO' }
];
